import { render, staticRenderFns } from "./collecIndex.vue?vue&type=template&id=349ad02d&scoped=true"
import script from "./collecIndex.vue?vue&type=script&lang=js"
export * from "./collecIndex.vue?vue&type=script&lang=js"
import style0 from "./collecIndex.vue?vue&type=style&index=0&id=349ad02d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349ad02d",
  null
  
)

export default component.exports